import React, { useState } from "react";
import { Appname } from "../../constant/constant";
import { userRole } from "../../constant/userConfig";
import logo from "../../img/logo.jpg";
import useAuthStore from "../../store/authStore";

import {
  AccountCircle,
  ChevronLeft,
  ChevronRight,
  Logout,
  Menu as MenuIcon,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  CssBaseline,
  Divider,
  Drawer,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  AppBar as MuiAppBar,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { deepOrange } from "@mui/material/colors";
import { styled, useTheme } from "@mui/material/styles";
import AgentMenu from "./menu/AgentMenu";
import AdminMenu from "./menu/admincinMenu";
import MedecinMenu from "./menu/medecinMenu";
import UserProfil from "./modals/UserProfil";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const SideBar = () => {
  const user = useAuthStore((state) => state.user);
  const role = user ? user.role : null;
  const [open, setOpen] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const logout = useAuthStore((state) => state.logout);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);
  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const [openProfil, setOpenProfil] = useState(false);

  const handleLogout = () => {
    logout();
    handleMenuClose();
  };
  const handleOpenProfil = () => {
    setOpenProfil(true);
    handleMenuClose();
  };

  if (role === userRole.medecin_assurance) {
    return (
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            bgcolor: "#37B049",
            boxShadow: "none",
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <Toolbar
            sx={{
              justifyContent: "space-between",
              padding: "0 24px",
              height: "64px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <img
                src={logo}
                alt="Logo"
                style={{
                  height: "40px",
                  objectFit: "contain",
                }}
              />
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{
                  fontWeight: 600,
                  letterSpacing: "0.5px",
                }}
              >
                {Appname}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Typography
                variant="subtitle1"
                noWrap
                sx={{
                  fontWeight: 500,
                  display: { xs: "none", sm: "block" },
                }}
              >
                {user?.name}
              </Typography>

              <IconButton
                onClick={handleMenuClick}
                size="small"
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                  },
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: deepOrange[500],
                    width: 36,
                    height: 36,
                    fontSize: "1rem",
                  }}
                >
                  {user?.name?.charAt(0).toUpperCase()}
                </Avatar>
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
              >
                <MenuItem onClick={handleOpenProfil}>
                  <ListItemIcon>
                    <AccountCircle fontSize="small" />
                  </ListItemIcon>
                  Profil
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Déconnexion
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </AppBar>
        {openProfil && (
          <UserProfil
            show={openProfil}
            handleClose={() => setOpenProfil(false)}
            user={user}
          />
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open} sx={{ bgcolor: "#37B049" }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            {Appname}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="subtitle1" noWrap>
              {user?.name}
            </Typography>
            <IconButton onClick={handleMenuClick} size="small">
              <Avatar sx={{ bgcolor: deepOrange[500], width: 32, height: 32 }}>
                {user?.name?.charAt(0).toUpperCase()}
              </Avatar>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleMenuClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={handleOpenProfil}>
                <ListItemIcon>
                  <AccountCircle fontSize="small" />
                </ListItemIcon>
                Profil
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Déconnexion
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant={isMobile ? "temporary" : "persistent"}
        anchor="left"
        open={open}
        onClose={handleDrawerClose}
      >
        <Toolbar>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? <ChevronLeft /> : <ChevronRight />}
          </IconButton>
        </Toolbar>
        <Divider />
        <Box sx={{ p: 2, textAlign: "center" }}>
          <img
            src={logo}
            alt="Logo"
            style={{ maxWidth: "80%", height: "auto" }}
          />
        </Box>
        <Divider />
        <Box sx={{ overflow: "auto" }}>
          {role === userRole.admin_assurance ? (
            <AdminMenu />
          ) : role === userRole.agent_assurance ? (
            <AgentMenu />
          ) : role === userRole.medecin_assurance ? (
            <MedecinMenu />
          ) : null}
        </Box>
      </Drawer>
      {openProfil && (
        <UserProfil
          show={openProfil}
          handleClose={() => setOpenProfil(false)}
          user={user}
        />
      )}
    </Box>
  );
};

export default SideBar;
